// import { PERMISSIONS_GENERAL } from 'constants/permissions';
import { SCOPES } from 'constants/roles';

export default [
  {
    scope: SCOPES.SYS_ADMIN,
    name: 'system-administration-instances-list',
    label: 'label.instances',
    navigationIcon: 'far fa-industry-alt',
    url: '/system-administration/instances/',
    pages: [
      {
        type: 'item',
        navigationIcon: 'far fa-id-card-alt',
        label: 'label.details',
        name: 'system-administration-instance-details',
        url: '/system-administration/instances/{id}/details',
      },
      {
        type: 'item',
        navigationIcon: 'far fa-box-full',
        label: 'label.purchases',
        name: 'system-administration-instance-purchases',
        url: '/system-administration/instances/{id}/purchases',
      },
      {
        type: 'item',
        class: 'is-delete',
        navigationIcon: 'fas fa-ban',
        label: 'label.block',
        name: 'system-administration-instance-block',
        url: '/system-administration/instances/{id}/block',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/navigations/system-administration/navigation-sys-admin-instances.js